
export default {
  namespaced: true,
  state: {
    tableId: '',
    isTried: false,
    promoterDrawer: false,
    promoterConfig1: {},
    approverDrawer: false,
    approverConfig1: {},
    copyerDrawer: false,
    copyerConfig1: {},
    conditionDrawer: false,
    conditionsConfig1: {
      branchList: []
    },
    transactorDrawer: false,
    transactorConfig1: {},
    permissionOption: [],
    promoterOptions: []
  },
  mutations: {
    setTableId (status, payload) {
      status.tableId = payload;
    },
    setIsTried (status, payload) {
      status.isTried = payload;
    },
    setPromoter (status, payload) {
      status.promoterDrawer = payload;
    },
    setPromoterConfig (status, payload) {
      status.promoterConfig1 = payload;
    },
    setApprover (status, payload) {
      status.approverDrawer = payload;
    },
    setApproverConfig (status, payload) {
      status.approverConfig1 = payload;
    },
    setCopyer (status, payload) {
      status.copyerDrawer = payload;
    },
    setCopyerConfig (status, payload) {
      status.copyerConfig1 = payload;
    },
    setTransactor (status, payload) {
      status.transactorDrawer = payload;
    },
    setTransactorConfig (status, payload) {
      status.transactorConfig1 = payload;
    },
    setCondition (status, payload) {
      status.conditionDrawer = payload;
    },
    setConditionsConfig (status, payload) {
      status.conditionsConfig1 = payload;
    },
    setPermissionOption (status, payload) {
      status.permissionOption = payload;
    },
    // 条件设置发起人选择框设置，留用
    setPromoterOptions (status, payload) {
      status.promoterOptions = payload;
    }
  },
  actions: {}
};
